import React from "react";
import { InputNumber, Form, Row, Col, Typography } from "antd";
const { Text } = Typography;

export default function SelectTicketType(props) {
  const { ticketTypes = [], quantities = {}, onChange } = props;

  return (
    <div>
      <Text strong>Tickets</Text>

      <Text type="secondary">Choose a quantity for each available item.</Text>
      <div style={{ marginTop: "1rem" }}>
        {ticketTypes.map((ticketType) => (
          <Row
            key={ticketType.id}
            align="middle"
            gutter={16}
            style={{ marginBottom: "0.75rem" }}
          >
            <Col flex="auto">
              <Text strong>{ticketType.name}</Text>
              {ticketType.unitPrice != null ? (
                <Text type="secondary" style={{ display: "block" }}>
                  ${Number(ticketType.unitPrice).toFixed(2)} each
                </Text>
              ) : null}
            </Col>
            <Col>
              <Form.Item style={{ margin: 0 }}>
                <InputNumber
                  aria-label={`${ticketType.name} quantity`}
                  value={quantities[ticketType.id] || 0}
                  onChange={(value) => onChange(ticketType.id, value || 0)}
                  min={0}
                  max={100}
                  precision={0}
                  keyboard
                />
              </Form.Item>
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
}
